import styled from "styled-components";

export const SearchBtnWrapper = styled.div`
  width: 100%;
  text-align: right;
  & button {
    margin-right: 0px !important;
  }
`;

export const RequestAccessLink = styled.div`
  text-align: left;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
  &:hover {
    cursor: pointer;
  }
`;

export const DialogContentWrapper = styled.div`
  width: 100%;
  margin: auto;
  text-align: center;
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
`;

export const IconWrapper = styled.div`
  font-size: 40px;
`;

export const MiniModalContentTitle = styled.div`
  text-align: center;
  font: normal normal 600 18px/24px Open Sans;
  letter-spacing: 0px;
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
`;

export const MiniModalContentBody = styled.div`
  padding: 10px 0px;
  text-align: center;
  font: normal normal normal 16px/20px Helvetica Neue;
  letter-spacing: 0px;
  color: ${({ theme }) => {
    return theme.colors.darkgrey;
  }};
`;
